import React from 'react'
import { Box, Flex, Divider } from 'rebass'
import { colors, fonts, fontSizes, fontWeights } from '../theme'
import styled from 'styled-components'
import Title from '../elements/Text/Title'

const DetailsContainer = styled(Box)`
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[3]+'px'};
  &:first-letter {
    font-weight: bold;
    font-size: ${fontSizes[6]+'px'};
  };
  color: ${colors.greyDark}
`
const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  margin-bottom: 2rem;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`
const About = () => (
  <Box px={5} py={6} style={{textAlign:'center'}}>
  <Title color={colors.primary}>
  About the Firm
    </Title>
    <TextSeparator/>
    <DetailsContainer>
      JAIN S N & Co. is a leading firm of Chartered Accountants established in
      2012. Led by eminent and highly experienced partners and complemented by a
      team of multi disciplinary professionals, we offer a diverse range of
      professional services to our clients, besides our core competencies of
      audit and taxation. With over 6 YEARS of experience, we have been
      providing advice and support to both domestic and international clients in
      diverse sectors on audit, accounting, taxation and regulatory matters.
      Built on a strong commitment to client service, the Firm acts as a
      One-Stop Advisor offering expertise and hands-on support. We pride
      ourselves on our quality and integrity to drive the growth of our clients.
    </DetailsContainer>
  </Box>
)

export default About



// WEBPACK FOOTER //
// ./src/pages/about.js